<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">AI Voice Agent</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-label">Aktif Agent Sayısı</div>
                <div class="feature-input">
                    <a-input type="number" v-model="featureForm.voiceAgentActiveCount" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Randevu Takibi</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentAppointmentTracking" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Toplu Arama Sayısı</div>
                <div class="feature-input">
                    <a-input type="number" v-model="featureForm.voiceAgentBulkCallCount" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Ses klonlama</div>
                <div class="feature-input">
                    <a-input type="number" v-model="featureForm.voiceAgentVoiceCloning" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Hazır ses kullanımı (OpenAI / ElevenLabs)</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentReadyVoiceOpenAI" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Community ses kullanımı (ElevenLabs)</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentCommunityVoice" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Aynı anda yapılabilen arama sayısı</div>
                <div class="feature-input">
                    <a-input type="number" v-model="featureForm.voiceAgentConcurrentCallCount" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Web Agent özelliği</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentWebAgent" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Chatbot üzerinden arama</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentChatbotCall" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Otomasyon üzerinden arama</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentAutomationCall" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Tablolar üzerinden arama</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentTableCall" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Kişiler üzerinden arama</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentContactCall" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">LLM Desteği</div>
                <div class="feature-input">
                    <a-select mode="multiple" v-model="featureForm.voiceAgentLlmSupport">
                        <a-select-option value="OpenAI">OpenAI</a-select-option>
                        <a-select-option value="Claude">Claude</a-select-option>
                        <a-select-option value="Gemini">Gemini</a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Özel LLM model entegrasyonu</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentCustomLlmIntegration" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Kendi Bilgi Tabanınız ile Eğitim</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentCustomDataTraining" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">IVR (Tuş basma aksiyonları alma)</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentIvr" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Özel Fonksiyonlar ekleme</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentCustomFunctions" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Duygu Analizi</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentSentimentAnalysis" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Gelişmiş Ses Ayarları</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentAdvancedVoiceSettings" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Telesekreter Algılama</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentSecretaryDetection" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Kişiselleştirilebilir Promptlar</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceAgentCustomPrompts" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    name: "VoiceAgentFeature",
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            voiceAgentEntegration: true,
            voiceAgentActiveCount: 5,
            voiceAgentAppointmentTracking: true,
            voiceAgentBulkCallCount: 100,
            voiceAgentVoiceCloning: 1,
            voiceAgentReadyVoiceOpenAI: true,
            voiceAgentCommunityVoice: false,
            voiceAgentConcurrentCallCount: 10,
            voiceAgentWebAgent: false,
            voiceAgentChatbotCall: true,
            voiceAgentAutomationCall: true,
            voiceAgentTableCall: true,
            voiceAgentContactCall: true,
            voiceAgentLlmSupport: ["OpenAI"],
            voiceAgentCustomLlmIntegration: false,
            voiceAgentCustomDataTraining: true,
            voiceAgentIvr: true,
            voiceAgentCustomFunctions: true,
            voiceAgentSentimentAnalysis: true,
            voiceAgentAdvancedVoiceSettings: true,
            voiceAgentSecretaryDetection: true,
            voiceAgentCustomPrompts: true
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.VOICE_AGENT);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.VOICE_AGENT, ...this.featureForm };
                response[Features.VOICE_AGENT.ACTIVE_AGENT_COUNT] = +v.voiceAgentActiveCount || 0;
                response[Features.VOICE_AGENT.VOICE_CLONING] = +v.voiceAgentVoiceCloning || 0;
                response[Features.VOICE_AGENT.CONCURRENT_CALL_COUNT] = +v.voiceAgentConcurrentCallCount || 0;
                response[Features.VOICE_AGENT.BULK_CALL_COUNT] = +v.voiceAgentBulkCallCount || 0;

                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.VOICE_AGENT);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }

    .feature-form {
        margin-top: 15px;

        .feature-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;

            .feature-label {
                flex: 1;
            }

            .feature-input {
                flex: 1;
            }
        }
    }
}
</style>
